<template>
  <div>
    <oil-cap
        :title='orderTitle.toUpperCase()'
        :buttons='buttons'
        :searchLocalFilter="searchLocal"
    />
    <v-divider class='my-2'/>
    <oil-table
        :keys='keys'
        :items='orders'
        :search="search"
        :color='color'
        :hideFooter="false"
    >

      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:Status='{object}'>
        <v-select
            class='font-weight-bold'
            :items='statuses'
            item-text='text'
            item-value='value'
            v-model='object.OrderStatus'
            @change='changeStatus(object.Id,object.OrderStatus)'
        />
      </template>

    </oil-table>


  </div>
</template>

<script>
import {orderService} from '@/services/OrderService'
import {coreApi} from '~/services/core'
import {table, cap} from './order_today.json'
import today from './globalFunctionsInThisDirectory'

export default {
  mixins: [today],
  data: () => ({
    orderTitle: cap.title,
    keys: table.keys,
    buttons: cap.buttons,
    orders: [],
    search: null,
    statuses: [
      {
        text: 'ТТН Создан',
        value: 'inprocess'
      },
      {
        text: 'ТТН в процессе',
        value: 'active'
      },
      {
        text: 'ТТН отгружен',
        value: 'fail'
      },
      {
        text: 'ТТН возрат',
        value: 'return'
      }
    ],
  }),
  async created() {

    const orders = await orderService.getOrdersToday()


    this.keys = this.keys.map(key => {
      return {
        text: key.text.toUpperCase(),
        value: key.value
      }
    })


    this.orders = orders.data?.map(order => {
      const waybillNumber = order?.WaybillNumber || 0
      let number
      if (order.WaybillNumber)
        number = order.ContractNumber ? `${order.ContractNumber}-${order.WaybillNumber}` : ''
      else
        number = ''
      return {
        ...order,
        CompanyName: order?.BuyerCompanyName,
        WaybillNumber: number,
        GrossPricePerLitre: this.regular(order.GrossPricePerLitre),
        GrossPricePerTonne: this.regular(order.GrossPricePerTonne)
      }
    })
  },
  components: {
    OilCap: () => import('@/components/helper/oil.cap'),
    OilTable: () => import('@/components/helper/oil.table')
  },
  methods: {
    handleRowClick(Id) {
      this.$router.push(`order-update/${Id}`)
    },
    searchLocal(input) {
      this.search = input
    },
    async changeStatus(id, status) {

      const params = {
        id, status
      }
      const itemStatus = await coreApi.get(`order/status`, {params})

    },
    color(item) {
      const itemStatus = item.OrderStatus
      if (itemStatus === 'fail') {
        return 'success-color'
      } else if (itemStatus === 'inprocess') {
        return ''
      } else if (itemStatus === 'active') {
        return 'warning-color'
      } else if (itemStatus === 'return') {
        return 'red-color'
      }
    }
  }
}
</script>

<style scoped>
/*.text-left {*/
/*  border-right: 2px solid gray;*/
/*}*/

/*.tbody {*/
/*  border-right: 2px solid gray;*/
/*}*/

/*tbody {*/
/*  text-align: center !important;*/
/*  font-weight: bold !important;*/
/*}*/

/*tbody:hover {*/
/*  cursor: pointer !important;*/
/*}*/

/*thead tr th {*/
/*  font-weight: bolder !important;*/
/*  text-shadow: 0 0 1px black !important;*/
/*  font-size: 14px !important;*/
/*  text-transform: uppercase !important;*/
/*  position: relative;*/
/*  text-align: center !important;*/
/*  padding: 0 100px !important;*/
/*}*/

/*thead {*/
/*  padding: 10px !important;*/
/*  outline: 3px solid black !important;*/
/*}*/

/*thead tr th :after {*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: 50%;*/
/*  margin-left: 50% !important;*/
/*  top: 0;*/
/*  height: 1500px !important;*/
/*  border-left: 2px solid grey !important;*/
/*  z-index: 1;*/
/*}*/

/*thead tr th {*/
/*  opacity: 1;*/
/*}*/

/*.red-color {*/
/*  background-color: #ff0000 !important;*/
/*  color: #f7f7f7;*/
/*  opacity: 0.8;*/
/*}*/

/*.warning-color {*/
/*  background-color: #ffff00 !important;*/
/*  color: black!important;*/
/*  opacity: 0.9;*/
/*}*/

/*.success-color {*/
/*  background-color: #00b24f !important;*/
/*  color: #f7f7f7;*/

/*  opacity: 0.8;*/
/*}*/


</style>